module.exports = __webpack_public_path__ + "img/maxwingaming.79bd55b4.svg";